import { Admin } from '../../clients/quipli-service/admin/admin';
import { useAdmin } from '../../hooks/use-admin-context';
import { useAdminApiV1 } from '../../clients/quipli-service/admin/admin-api-v1';
import React, { useCallback, useEffect } from 'react';
import { debounce } from 'lodash';
import { Typography } from '../../components/typography/typography';
import { AsyncSelectForm } from '../../components/select-form/select-form';
import { components } from 'react-select';
import Icon from '../../components/icons/icon';
import classNames from 'classnames';

export const PurchaseAdminSelect = ({
  admin,
  setAdmin,
  useSignedAdminAsDefault = false,
}: {
  admin?: Admin;
  setAdmin?: (a?: Admin) => void;
  useSignedAdminAsDefault?: boolean;
}) => {
  const { id } = useAdmin();
  const { getUserAdmin, getAdminsList } = useAdminApiV1();

  // TODO: ignore super admin
  const search = useCallback(
    debounce((keyword: string, callback) => {
      getAdminsList(false).then((res) => callback(res));
    }, 300),
    [],
  );

  useEffect(() => {
    useSignedAdminAsDefault && getUserAdmin(id).then((res) => setAdmin?.(res));
  }, [useSignedAdminAsDefault]);

  return (
    <>
      <AsyncSelectForm<Admin>
        cacheOptions
        defaultOptions
        isRequired
        label="Purchased By"
        loadOptions={search}
        getOptionLabel={(op) => op.adminFullName}
        getOptionValue={(op) => `${op.adminId}`}
        onChange={(value) => setAdmin?.(value || undefined)}
        loadingMessage={() => 'Loading admins...'}
        noOptionsMessage={() => 'No admins found'}
        dataCy="customer-select"
        value={admin}
        components={{
          Placeholder: (props) => (
            <components.Placeholder {...props}>
              <Typography type="text-sm">Search admins</Typography>
            </components.Placeholder>
          ),
          ValueContainer: (props) => (
            <div className="flex items-center gap-[6px] pl-[10px]">
              <Icon icon="Search" size="medium" stroke="var(--grey-500)" />
              <components.ValueContainer {...props} />
            </div>
          ),
          Option: (props) => (
            <components.Option {...props}>
              <div className={classNames('flex items-center gap-[6px] justify-between')}>
                <div className="flex flex-col gap-[4px]">
                  <Typography type="text-md" weight="medium" className="text-grey-900">
                    {props.children}
                  </Typography>
                  <div>
                    <Typography type="text-sm" className="text-grey-500">
                      {props.data.adminUsername}
                    </Typography>
                  </div>
                </div>
                {props.isSelected && <Icon icon="Check" stroke="var(--quipli-black-800)" />}
              </div>
            </components.Option>
          ),
        }}
      />
    </>
  );
};
